<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="9">
        <p class="mb-1">
          <span class="title font-weight-bold text--primary">
            Status da integração (ERP)
          </span>
        </p>
        <p class="mb-1">
          <span class="font-weight text--secondary">
            Histórico de atualizações no ERP
          </span>
        </p>
      </v-col>
      <v-col cols="12" sm="3" class="justify-end">
        <v-card-actions>
          <div class="actions">
            <px-listagem-logs-integracao-filtros @change="emitChange" />
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="onClickRefresh">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Atualizar lista de mensagens da integração</span>
          </v-tooltip>
          <v-btn color="primary" class="normal-btn-text rounded-tag-small" small :loading="loading"
            :disabled="integracaoIniciada" @click="onCLickIniciarIntegracao">
            <v-icon small left>mdi-connection</v-icon>
            Atualizar integração
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>
<script>
import IntegracaoService from '@/api/integracao-service';
import ListagemLogsIntegracaoFiltros from './ListagemLogsIntegracaoFiltros.vue';

export default {
  props: {
    onClickRefresh: Function,
  },
  data() {
    return {
      integracaoIniciada: false,
      loading: false,
    };
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
    iniciarIntegracao() {
      this.loading = true;
      IntegracaoService.iniciarIntegracao()
        .then(() => {
          this.$toast('Integração iniciada com sucesso', { color: 'success' });
          this.integracaoIniciada = true;
        })
        .finally(() => {
          this.loading = false;
          this.getLogs();
        });
    },
    onCLickIniciarIntegracao() {
      this.$refs.confirm.open('Você deseja iniciar o processo de integração?',
        'A integração será iniciada e não pode ser parada.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.iniciarIntegracao();
        });
    },
  },
  components: {
    pxListagemLogsIntegracaoFiltros: ListagemLogsIntegracaoFiltros,
  },
};
</script>
<style scoped>
.actions {
  width: 30px;
  height: 35px;
}
</style>
